import { render, staticRenderFns } from "./clientdashboard-login.vue?vue&type=template&id=3a05fa36&"
import script from "./clientdashboard-login.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports